import "core-js/modules/es.array.map";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import _objectSpread from "D:/work/admin/colocess_web_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/colocess_web_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serchSelect } from "@/mixins/index";
export default {
  mixins: [serchSelect],
  props: {
    languageLists: {
      type: Array
    }
  },
  data: function data() {
    return {
      dialogShow: false,
      form: {
        params: []
      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(datas) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogShow = true;

                if (datas) {
                  data = JSON.parse(JSON.stringify(datas));
                  data.language = data.language.split(',');
                  data.params.map(function (i) {
                    i.picfileList = [i.icon];
                  });
                  _this.form = _objectSpread({}, data);
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};